const mapping: { [k: string]: string } = {
    "AFGHANISTAN": "AF",
    "ALBANIA": "AL",
    "ALGERIA": "DZ",
    "ANDORRA": "AD",
    "ANGOLA": "AO",
    "ANGUILLA (ISOLA)": "AI",
    "ANTIGUA E BARBUDA": "AG",
    "APOLIDE": "XX",
    "ARABIA SAUDITA": "SA",
    "ARGENTINA": "AR",
    "ARMENIA": "AM",
    "AUSTRALIA": "AU",
    "AUSTRIA": "AT",
    "AZERBAIGIAN": "AZ",
    "BAHAMA": "BS",
    "BAHREIN": "BH",
    "BANGLADESH": "BD",
    "BARBADOS": "BB",
    "BELGIO": "BE",
    "BELIZE": "BZ",
    "BENIN": "BJ",
    "BERMUDE": "BM",
    "BHUTAN": "BT",
    "BIELORUSSIA": "BY",
    "BOLIVIA": "BO",
    "BOSNIA ED ERZEGOVINA": "BA",
    "BOTSWANA": "BW",
    "BRASILE": "BR",
    "BRUNEI": "BN",
    "BULGARIA": "BG",
    "BURKINA FASO": "BF",
    "BURUNDI": "BI",
    "CAMBOGIA": "KH",
    "CAMERUN": "CM",
    "CANADA": "CA",
    "CAPO VERDE": "CV",
    "CAYMAN (ISOLE)": "KY",
    "CENTRAFRICA": "CF",
    "CHRISTMAS": "CX",
    "CIAD": "TD",
    "CILE": "CL",
    "CINA POPOLARE": "CN",
    "CIPRO": "CY",
    "CITTA' DEL VATICANO": "VA",
    "COCOS": "CC",
    "COLOMBIA": "CO",
    "COMORE": "KM",
    "CONGO": "CG",
    "COREA DEL NORD": "KP",
    "COREA DEL SUD": "KR",
    "COSTA D'AVORIO": "CI",
    "COSTARICA": "CR",
    "CROAZIA": "HR",
    "CUBA": "CU",
    "DANIMARCA": "DK",
    "DOMINICA": "DM",
    "ECUADOR": "EC",
    "EGITTO": "EG",
    "EL SALVADOR": "SV",
    "EMIRATI ARABI UNITI": "AE",
    "ERITREA": "ER",
    "ESTONIA": "EE",
    "ETIOPIA": "ET",
    "FAER OER": "FO",
    "FIGI": "FJ",
    "FILIPPINE": "PH",
    "FINLANDIA": "FI",
    "FRANCIA": "FR",
    "GABON": "GA",
    "GAMBIA": "GM",
    "GEORGIA": "GE",
    "GERMANIA": "DE",
    "GHANA": "GH",
    "GIAMAICA": "JM",
    "GIAPPONE": "JP",
    "GIBUTI": "DJ",
    "GIORDANIA": "JO",
    "GRECIA": "GR",
    "GRENADA": "GD",
    "GROENLANDIA": "GL",
    "GUADALUPA": "GP",
    "GUAM": "GU",
    "GUATEMALA": "GT",
    "GUAYANA FRANCESE": "GF",
    "GUINEA": "GN",
    "GUINEA BISSAU": "GW",
    "GUINEA EQUATORIALE": "GQ",
    "GUYANA": "GY",
    "HAITI": "HT",
    "HONDURAS": "HN",
    "HONG KONG": "HK",
    "INDIA": "IN",
    "INDONESIA": "ID",
    "IRAN": "IR",
    "IRAQ": "IQ",
    "IRLANDA": "IE",
    "ISLANDA": "IS",
    "ISOLE VERGINI": "VI",
    "ISRAELE": "IL",
    "KAZAKISTAN": "KZ",
    "KENIA": "KE",
    "KIRGHIZISTAN": "KG",
    "KIRIBATI": "KI",
    "KOSOVO": "XK",
    "KUWAIT": "KW",
    "LAOS": "LA",
    "LA REUNION": "RE",
    "LESOTHO": "LS",
    "LETTONIA": "LV",
    "LIBANO": "LB",
    "LIBERIA": "LR",
    "LIBIA": "LY",
    "LIECHTENSTEIN": "LI",
    "LITUANIA": "LT",
    "LUSSEMBURGO": "LU",
    "MACAO": "MO",
    "MADAGASCAR": "MG",
    "MALAWI": "MW",
    "MALAYSIA": "MY",
    "MALDIVE": "MV",
    "MALI": "ML",
    "MALTA": "MT",
    "MALVINE": "FK",
    "MAN": "IM",
    "MAROCCO": "MA",
    "MARSHALL": "MH",
    "MARTINICA": "MQ",
    "MAURITANIA": "MR",
    "MAURIZIO": "MU",
    "MAYOTTE": "YT",
    "MESSICO": "MX",
    "MICRONESIA STATI FEDERALI": "FM",
    "MOLDAVIA": "MD",
    "MONACO": "MC",
    "MONGOLIA": "MN",
    "MONTENEGRO": "ME",
    "MONTSERRAT": "MS",
    "MOZAMBICO": "MZ",
    "MYANMAR (BIRMANIA)": "MM",
    "NAMIBIA": "NA",
    "NAURU": "NR",
    "NEPAL": "NP",
    "NICARAGUA": "NI",
    "NIGER": "NE",
    "NIGERIA": "NG",
    "NORFOLK": "NF",
    "NORVEGIA": "NO",
    "NUOVA CALEDONIA": "NC",
    "NUOVA ZELANDA": "NZ",
    "OMAN": "OM",
    "PAESI BASSI": "NL",
    "PAKISTAN": "PK",
    "PALAU REPUBBLICA": "PW",
    "PALESTINA": "PS",
    "PANAMA": "PA",
    "PAPUASIA-N.GUINEA": "PG",
    "PARAGUAY": "PY",
    "PERU'": "PE",
    "PITCAIRN": "PN",
    "POLINESIA": "PF",
    "POLONIA": "PL",
    "PORTOGALLO": "PT",
    "PUERTO RICO": "PR",
    "QATAR": "QA",
    "REGNO UNITO": "GB",
    "REP. DOMINICANA": "DO",
    "REPUBBLICA CECA": "CZ",
    "REPUBBLICA DEMOCRATICA DEL CONGO": "CD",
    "REPUBBLICA DI MACEDONIA DEL NORD": "MK",
    "REPUBBLICA SLOVACCA": "SK",
    "ROMANIA": "RO",
    "RUANDA": "RW",
    "RUSSIA": "RU",
    "SAHARA SPAGNOLO": "EH",
    "SAINT LUCIA": "LC",
    "SAINT PIERRE ET MIQUELON": "PM",
    "SAINT VINCENT E GRENADINE": "VC",
    "SALOMONE": "SB",
    "SAMOA": "WS",
    "SAMOA AMERICANE": "AS",
    "SAN MARINO": "SM",
    "SANT ELENA": "SH",
    "SAO TOME' E PRINCIPE": "ST",
    "S. CHRISTOPHER E NEVIS": "KN",
    "SEICELLE": "SC",
    "SENEGAL": "SN",
    "SERBIA": "RS",
    "SIERRA LEONE": "SL",
    "SINGAPORE": "SG",
    "SIRIA": "SY",
    "SLOVENIA": "SI",
    "SOMALIA": "SO",
    "SPAGNA": "ES",
    "SRI LANKA (CEYLON)": "LK",
    "STATI UNITI D'AMERICA": "US",
    "SUD AFRICA": "ZA",
    "SUDAN": "SD",
    "SUD SUDAN": "SS",
    "SURINAME": "SR",
    "SVEZIA": "SE",
    "SVIZZERA": "CH",
    "SWAZILAND": "SZ",
    "TAGIKISTAN": "TJ",
    "TAIWAN": "TW",
    "TANZANIA": "TZ",
    "THAILANDIA": "TH",
    "TIMOR": "TL",
    "TOGO": "TG",
    "TOKELAU": "TK",
    "TONGA": "TO",
    "TRINIDAD E TOBAGO": "TT",
    "TUNISIA": "TN",
    "TURCHIA": "TR",
    "TURKMENISTAN": "TM",
    "TURKS": "TC",
    "TUVALU": "TV",
    "UCRAINA": "UA",
    "UGANDA": "UG",
    "UNGHERIA": "HU",
    "URUGUAY": "UY",
    "UZBEKISTAN": "UZ",
    "VANUATU": "VU",
    "VENEZUELA": "VE",
    "VERGINI BRITANNICHE (ISOLE)": "VG",
    "VIETNAM": "VN",
    "WALLIS": "WF",
    "YEMEN": "YE",
    "ZAMBIA": "ZM",
    "ZIMBABWE": "ZW",
};

export default mapping;
